import React from 'react';
import { Image } from 'react-native';
import type { PodcastProps } from '../types';
import { SocialPodcastHelpers } from './api';
import moment from 'moment-mini';
import { Button, Text, View } from '../Components/Themed';

type PodcastCardType = {
    podcast:PodcastProps,
    width:number,
    onSelectPodcast:(podcast:PodcastProps) => void
}
const PodcastCard = ({ podcast, width, onSelectPodcast }:PodcastCardType) => {
    return (
        <Button style={{ width, padding:0, flex:1 }} onPress={() => onSelectPodcast(podcast)}>
            <Image
                source={{ uri: SocialPodcastHelpers.getPodcastImage(podcast) }}
                style={{ width:width, height:width*0.666, borderTopRightRadius:8, borderTopLeftRadius:8 }}
                resizeMode='cover'
            />
            <View style={{ padding:10, flexGrow:1 }}>
                <Text theme='h2'>{podcast.title}</Text>
            </View>
            <View type='footer' style={{ padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <Text theme='description'>{moment(podcast.last_update_datetime).fromNow()}</Text>
            </View>
        </Button>
    )
}
export default PodcastCard